
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexlgPbDKquVo_45GD7I62q7eIcRvV8sZUl9wbTzs7c8D8S0Meta } from "/workspace/nuxt/pages/index.vue?macro=true";
import { default as press1ElpppgN9E_ee4uOb15I6H0ymHaSTlW_AWRleYPW7eAMeta } from "/workspace/nuxt/pages/press.vue?macro=true";
import { default as _91slug_93cg01B4V74gCD_454L_459tWLq9GZD_45QUnKcOFRr__45LDXRJQMeta } from "/workspace/nuxt/pages/[slug].vue?macro=true";
import { default as _91slug_932tWR9SzYikEcdEd_45RYQnPE_41X1qc1iOMkI0vizeIgkMeta } from "/workspace/nuxt/pages/events/[slug].vue?macro=true";
import { default as eventsSh3_wMm7u5PQkMMutIp1URre1XfQqxsu3GLdZZ4abvMMeta } from "/workspace/nuxt/pages/events.vue?macro=true";
import { default as _91slug_934HBuQh8yunWvDo3Mcn7hKtvOqtzyBWs_cqlGpP_45gEx4Meta } from "/workspace/nuxt/pages/projects/[slug].vue?macro=true";
import { default as projects4BWPXcLVLx0eTJAokX9Euf7y98gpBgv0PlUECo5W7CwMeta } from "/workspace/nuxt/pages/projects.vue?macro=true";
import { default as _91slug_93456TaevsBDr5VhlJxT1MkJkE4C_451zZbBNzhp6ZSjulsMeta } from "/workspace/nuxt/pages/education/[slug].vue?macro=true";
import { default as educationDzquhEVNsKtNFXv_45Btpogv5QXFK45474TJ_u8SMK1FMMeta } from "/workspace/nuxt/pages/education.vue?macro=true";
import { default as newsletterDoTjlMymi4KZu_45nu4x8Ss6EC1AmW_XzY_45El4x9SXkygMeta } from "/workspace/nuxt/pages/newsletter.vue?macro=true";
import { default as page_45previewiWBwQniWPgusdJ_16qYD3_45Grp3pb00ydZJG0cN759ToMeta } from "/workspace/nuxt/pages/page-preview.vue?macro=true";
import { default as indexwV_4U3HrFvwADMX5Pw_45FNLXJahneYv5hwykPDg_C0yUMeta } from "/workspace/nuxt/pages/journals/index.vue?macro=true";
import { default as _91slug_93KWsPSZ7gN_W9iXLX8JYQFtYd0Cd_45PEWOEhEynXfD9G4Meta } from "/workspace/nuxt/pages/journals/[slug].vue?macro=true";
import { default as indexu1yoxUUDGdyfCp4KhB3la6gMT2UVaAa2D4ZV9U08FPcMeta } from "/workspace/nuxt/pages/exhibitions/index.vue?macro=true";
import { default as indexWWoUcgcXqcn20XLA6vD6CA1VuhPB_7Bkx2ICIWi1z8cMeta } from "/workspace/nuxt/pages/exhibitions/[slug]/index.vue?macro=true";
import { default as documentationApEqry1kKAvxiHbwY3ZmOFCU5WnqknxB5hqQ85Q5XycMeta } from "/workspace/nuxt/pages/exhibitions/[slug]/documentation.vue?macro=true";
import { default as component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXgMeta } from "/workspace/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXg } from "/workspace/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___nl",
    path: "/",
    component: () => import("/workspace/nuxt/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/workspace/nuxt/pages/index.vue")
  },
  {
    name: "press___nl",
    path: "/press",
    component: () => import("/workspace/nuxt/pages/press.vue")
  },
  {
    name: "press___en",
    path: "/en/press",
    component: () => import("/workspace/nuxt/pages/press.vue")
  },
  {
    name: "slug___nl",
    path: "/:slug()",
    component: () => import("/workspace/nuxt/pages/[slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug()",
    component: () => import("/workspace/nuxt/pages/[slug].vue")
  },
  {
    name: "events___nl",
    path: "/events",
    component: () => import("/workspace/nuxt/pages/events.vue"),
    children: [
  {
    name: "events-slug___nl",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/events/[slug].vue")
  }
]
  },
  {
    name: "events___en",
    path: "/en/events",
    component: () => import("/workspace/nuxt/pages/events.vue"),
    children: [
  {
    name: "events-slug___en",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/events/[slug].vue")
  }
]
  },
  {
    name: "projects___nl",
    path: "/projects",
    component: () => import("/workspace/nuxt/pages/projects.vue"),
    children: [
  {
    name: "projects-slug___nl",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/projects/[slug].vue")
  }
]
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/workspace/nuxt/pages/projects.vue"),
    children: [
  {
    name: "projects-slug___en",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/projects/[slug].vue")
  }
]
  },
  {
    name: "education___nl",
    path: "/education",
    component: () => import("/workspace/nuxt/pages/education.vue"),
    children: [
  {
    name: "education-slug___nl",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/education/[slug].vue")
  }
]
  },
  {
    name: "education___en",
    path: "/en/education",
    component: () => import("/workspace/nuxt/pages/education.vue"),
    children: [
  {
    name: "education-slug___en",
    path: ":slug()",
    component: () => import("/workspace/nuxt/pages/education/[slug].vue")
  }
]
  },
  {
    name: "newsletter___nl",
    path: "/newsletter",
    meta: newsletterDoTjlMymi4KZu_45nu4x8Ss6EC1AmW_XzY_45El4x9SXkygMeta || {},
    component: () => import("/workspace/nuxt/pages/newsletter.vue")
  },
  {
    name: "newsletter___en",
    path: "/en/newsletter",
    meta: newsletterDoTjlMymi4KZu_45nu4x8Ss6EC1AmW_XzY_45El4x9SXkygMeta || {},
    component: () => import("/workspace/nuxt/pages/newsletter.vue")
  },
  {
    name: "page-preview",
    path: "/page-preview",
    component: () => import("/workspace/nuxt/pages/page-preview.vue")
  },
  {
    name: "journals___nl",
    path: "/journals",
    component: () => import("/workspace/nuxt/pages/journals/index.vue")
  },
  {
    name: "journals___en",
    path: "/en/journals",
    component: () => import("/workspace/nuxt/pages/journals/index.vue")
  },
  {
    name: "journals-slug___nl",
    path: "/journals/:slug()",
    component: () => import("/workspace/nuxt/pages/journals/[slug].vue")
  },
  {
    name: "journals-slug___en",
    path: "/en/journals/:slug()",
    component: () => import("/workspace/nuxt/pages/journals/[slug].vue")
  },
  {
    name: "exhibitions___nl",
    path: "/exhibitions",
    component: () => import("/workspace/nuxt/pages/exhibitions/index.vue")
  },
  {
    name: "exhibitions___en",
    path: "/en/exhibitions",
    component: () => import("/workspace/nuxt/pages/exhibitions/index.vue")
  },
  {
    name: "exhibitions-slug___nl",
    path: "/exhibitions/:slug()",
    component: () => import("/workspace/nuxt/pages/exhibitions/[slug]/index.vue")
  },
  {
    name: "exhibitions-slug___en",
    path: "/en/exhibitions/:slug()",
    component: () => import("/workspace/nuxt/pages/exhibitions/[slug]/index.vue")
  },
  {
    name: "exhibitions-slug-documentation___nl",
    path: "/exhibitions/:slug()/documentation",
    component: () => import("/workspace/nuxt/pages/exhibitions/[slug]/documentation.vue")
  },
  {
    name: "exhibitions-slug-documentation___en",
    path: "/en/exhibitions/:slug()/documentation",
    component: () => import("/workspace/nuxt/pages/exhibitions/[slug]/documentation.vue")
  },
  {
    name: component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXg
  },
  {
    name: component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXgMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub5aARkJkgIMmrTu7pJtf3f3HKgGKLY6iW_J_45cAnqjYXg
  }
]